<script lang="ts">
    export let line1: string
    export let line2: string
    export let line3: string

    let imgHeight: number = 0
</script>

<div class="engraving_preview" bind:clientHeight="{imgHeight}">
    <img src="/media/edelstahl.jpg" alt="" />
    <div class="line line1" style="font-size: {imgHeight / 4}px">
        {line1 || ""}
    </div>
    <div class="line line2" style="font-size: {imgHeight / 4}px">
        {line2 || ""}
    </div>
    <div class="line line3" style="font-size: {imgHeight / 1.4}px">
        {line3 || ""}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    .engraving_preview {
        position: relative;

        img {
            width: 100%;
            border: 1px solid var(--secondary);
            border-radius: var(--mainborder-radius);
        }

        .line {
            font-family: "Engraving";
            position: absolute;
            line-height: 100%;
        }

        .line1 {
            top: 20%;
            left: 6%;
        }
        .line2 {
            bottom: 25%;
            left: 6%;
        }
        .line3 {
            top: 15%;
            right: 10%;
        }
    }
</style>
